import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import {
  Container,
  Grid,
  Segment,
  Header,
  TextArea,
  Button,
  Dropdown
} from 'semantic-ui-react';
import { DateInput, TimeInput } from 'semantic-ui-calendar-react';
import { setToast } from '../../store/ToastManagement';
import { useLanceToCustomers, servicesAPI } from '../../_services';
import { history } from '../../_helpers';
import { useCurrentUser } from '../../_services/hooks';
import './customerDetail_styles.css';

const moment = extendMoment(Moment);

const lightOptions = [
  { text: "Don't know", value: 'Unknown' },
  { text: 'No lights', value: 'NoLights' },
  { text: 'Green (steady)', value: 'GreenSteady' },
  { text: 'Green (flashing)', value: 'GreenFlashing' },
  { text: 'Blue (steady)', value: 'BlueSteady' },
  { text: 'Blue (flashing)', value: 'BlueFlashing' },
  { text: 'Red (steady)', value: 'RedSteady' },
  { text: 'Red (flashing)', value: 'RedFlashing' }
];

export const CustomerSupport = () => {
  const { currentUser, currentUserIsCustomer, customerId } = useCurrentUser();
  const lanceToCustomers = useLanceToCustomers(customerId);

  const [session, setSession] = useState(null);
  const [phalanx, setPhalanx] = useState(null);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [description, setDescription] = useState('');
  const [lanceTopLights, setLanceTopLights] = useState('Unknown');
  const [edgeLights, setEdgeLights] = useState('Unknown');

  const [contactUsMessage, setContactUsMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // TDTODO Choosing first Lance but customer may have multiple Lances
  const lanceToCustomer = lanceToCustomers.length ? lanceToCustomers[0] : null;

  async function getPhalanx(phalanxTagId) {
    try {
      const response = await servicesAPI.InventoryServices(
        'getPhalanx',
        phalanxTagId
      );
      setPhalanx(response);
    } catch (error) {}
  }

  async function getSession(lanceToCustomer) {
    try {
      const response = await servicesAPI.MeteringServices(
        'getSessionByLanceToCustomer',
        lanceToCustomer.id
      );
      setSession(response);
      getPhalanx(response.phalanx_tag_id);
    } catch (error) {}
  }

  useEffect(() => {
    if (lanceToCustomers.length) getSession(lanceToCustomer);
  }, [lanceToCustomers]); // eslint-disable-line

  useEffect(() => {
    setDate(moment().format('DD/MM/YYYY'));
    setTime(moment().format('HH:mm'));
  }, []);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  if (!currentUser) {
    return <div>Loading...</div>;
  }

  if (!currentUserIsCustomer) {
    history.push(`/404`);
  }

  const handleReportProblem = () => {
    setSubmitting(true);

    const y = date.substring(6, 10);
    const m = date.substring(3, 5);
    const d = date.substring(0, 2);
    const timestamp = `${y}-${m}-${d} ${time}`;

    const values = {
      timestamp: timestamp,
      customer_id: customerId,
      lance_tag_id: lanceToCustomer ? lanceToCustomer.lance_tag_id : '',
      hydra_tag_id: phalanx ? phalanx.hydra_tag_id : '',
      phalanx_tag_id: session ? session.phalanx_tag_id : '',
      phalanx_ref: phalanx ? phalanx.reference : '',
      details: description,
      lance_top_lights: lanceTopLights,
      edge_lights: edgeLights
    };

    servicesAPI.AdminServices('createOrionByCustomer', values).then(
      response => {
        displayMessage('Success', 'Problem reported', true);
        setDescription('');
        setSubmitting(false);
      },
      error => {
        displayMessage('Error', 'Error reporting problem', false);
      }
    );
  };

  const _handleContactUs = () => {
    const values = {
      from_email: currentUser.user_name,
      message: contactUsMessage
    };

    servicesAPI.CustomerServices('support', values, customerId).then(
      response => {
        displayMessage('Success', 'Support message sent', true);
        setDescription('');
      },
      error => {
        displayMessage('Error', 'Error sending support message', false);
      }
    );
  };

  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">SUPPORT</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h4">HELP GUIDES</Header>
                      <Button
                        style={{
                          width: '100%'
                        }}
                        color="olive"
                      >
                        <a
                          className="tel-anchor"
                          href="https://trojan.energy/faq"
                        >
                          FAQs ON TROJAN ENERGY WEBSITE
                        </a>
                      </Button>
                    </Grid.Column>
                    <br />
                    <br />
                    <br />
                    <br />
                    <Grid.Column>
                      <Button
                        style={{
                          width: '100%'
                        }}
                        color="olive"
                      >
                        <a
                          className="tel-anchor"
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://trojan.energy/charging-manual"
                        >
                          CHARGING MANUAL
                        </a>
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h4">REPORT A PROBLEM</Header>
                      <DateInput
                        name="date"
                        placeholder="Date"
                        value={date}
                        dateFormat="DD/MM/YYYY"
                        onChange={(e, inputProps) => {
                          setDate(inputProps.value);
                        }}
                        animation={false}
                        style={{ width: 150 }}
                      />
                      <TimeInput
                        name="time"
                        placeholder="00:00"
                        value={time}
                        onChange={(e, inputProps) => {
                          setTime(inputProps.value);
                        }}
                        style={{ width: 150 }}
                      />
                      <Header
                        sub
                        color="grey"
                        as="h3"
                        style={{ marginBottom: '10px' }}
                      >
                        Description
                      </Header>
                      <TextArea
                        value={description}
                        onChange={(e, inputProps) => {
                          setDescription(inputProps.value);
                        }}
                        style={{ minHeight: 200, width: '100%' }}
                      />
                      <Header
                        sub
                        color="grey"
                        as="h3"
                        style={{ marginBottom: '10px' }}
                      >
                        Lights on top of lance
                      </Header>
                      <Dropdown
                        selection
                        search
                        options={lightOptions}
                        onChange={(e, inputProps) => {
                          setLanceTopLights(inputProps.value);
                        }}
                        value={lanceTopLights}
                      />
                      <Header
                        sub
                        color="grey"
                        as="h3"
                        style={{ marginBottom: '10px' }}
                      >
                        Lights on edge of charge point
                      </Header>
                      <Dropdown
                        selection
                        search
                        options={lightOptions}
                        onChange={(e, inputProps) => {
                          setEdgeLights(inputProps.value);
                        }}
                        value={edgeLights}
                      />
                      <br />
                      <br />
                      <Button
                        style={{
                          width: '100%'
                        }}
                        onClick={() => {
                          handleReportProblem();
                        }}
                        disabled={description.length === 0 || submitting}
                        color="olive"
                      >
                        REPORT PROBLEM
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Button
                        style={{
                          width: '100%'
                        }}
                        color="olive"
                      >
                        <a className="tel-anchor" href="tel:0800-0854-644">
                          0800 0854 644
                        </a>
                      </Button>
                    </Grid.Column>
                    <br />
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Header as="h4">
                        CONTACT US (or email{' '}
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href="mailto:support@trojan.energy"
                        >
                          support@trojan.energy
                        </a>
                        )
                      </Header>
                      <TextArea
                        value={contactUsMessage}
                        onChange={(e, inputProps) => {
                          setContactUsMessage(inputProps.value);
                        }}
                        style={{ minHeight: 200, width: '100%' }}
                      />
                      <br />
                      <Button
                        style={{
                          width: '100%'
                        }}
                        onClick={() => {
                          _handleContactUs();
                        }}
                        disabled={contactUsMessage.length === 0}
                        color="olive"
                      >
                        SEND MESSAGE
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
